import { AppLayoutBreakpoint } from '../../../util/responsiveness';

import { useContentContainerContext } from './useContentContainerContext';

type UseShouldRenderSidebarAtCurrentWidth = () => boolean;
export const useShouldRenderContentSidebarAtCurrentWidth: UseShouldRenderSidebarAtCurrentWidth = () => {
  const { contentContainerWidth } = useContentContainerContext();

  return contentContainerWidth >= AppLayoutBreakpoint.Width812;
};
